import React from "react";
import { Box, Typography, MenuItem } from "@mui/material";
import Button from "../components/common/Button/Button";
import IosShareIcon from "@mui/icons-material/IosShare";
import seller_bg from "../assets/images/seller.png";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import pro_black from "../assets/svgs/pro_black.svg";
import Field from "../components/common/Field/Fi";
import ListingCard from "../components/common/ListingCard/ListingCard";
import useMediaQuery from "@mui/material/useMediaQuery";
import Snackbar from "../components/common/Snackbar/Snackbar";
import eq from "../assets/images/equipo.png";
import Map from "../assets/images/map_seller.png";
import SellerShareModal from "../components/common/Modal/SellerShareModal";
import EmbedModal from "../components/common/Modal/EmbedModal";
import seller_mob from "../assets/images/seller_mob.png";
import Btn from "@mui/material/Button";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import sort from "../assets/svgs/sort.svg";
import BottomSortModal from "../components/common/Modal/BottomSortModal";
import BreadCrumbs from "../components/common/BreadCrumbs/BreadCrumbs";

const list = [1, 2, 3, 4, 5, 6];
const equipments = [
  "✓ Aerial Platforms",
  "✓ Attachments",
  "✓ Bus Coaches",
  "✓ Cranes",
  "✓ Crushing equipment",
  "✓ Dozers",
  "✓ Drilling equipment",
  "✓ Dump Trucks",
  "✓ Excavators",
  "✓ Forklift",
  "✓ Loaders",
  "✓ Service Truck",
  "✓ Road construction equipment",
  "✓ Semi-trailers",
  "✓ Telescopic handlers",
  "✓ Tractor Units",
  "✓ Tractors",
  "✓ Trailers",
  "✓ Trucks",
  "✓ Utility Service",
  "✓ Vans",
];
const filters = [
  { label: "Best Match", val: "bm" },
  { label: "Price (High)", val: "ph" },
  { label: "Price (Low)", val: "pl" },
  { label: "Hours (Most)", val: "hm" },
  { label: "Hours (Least)", val: "hl" },
  { label: "Year (Newest)", val: "yn" },
  { label: "Year (Oldest)", val: "yo" },
];

const Seller = () => {
  const [tab, setTab] = React.useState(0);
  const tabMatch = useMediaQuery("(max-width:900px)");
  const mobMatch = useMediaQuery("(max-width:600px)");
  const [sortVal, setSortVal] = React.useState(filters[0].val);
  const [showSnackbar, setShowSnackbar] = React.useState(false);
  const [showCompare, setShowCompare] = React.useState(false);
  const [comparing, setComparing] = React.useState(false);
  const [count, setCount] = React.useState(0);
  const [showShareModal, setShowShareModal] = React.useState(false);
  const [showEmbedModal, setShowEmbedModal] = React.useState(false);
  const [showSortBy, setShowSortBy] = React.useState(false);

  const handleSortVal = (e) => {
    setSortVal(e.target.value);
  };
  const handleSnackbarOpen = (e) => {
    setShowSnackbar(true);
    setComparing(true);
    if (!e || e.target.checked) setCount((oldCount) => oldCount + 1);
    else {
      if (count - 1 == 0) setComparing(false);
      setCount((oldCount) => oldCount - 1);
    }
  };
  const toggleDrawerSort = (open) => (event) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setShowSortBy(open);
  };
  const handleCompare = () => {
    setShowCompare(true);
    setShowSnackbar(false);
    setComparing(false);
    setCount(0);
  };

  const handleSnackbarClose = (_, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setShowSnackbar(false);
  };

  const listingComponent = (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        width: { xs: "100%", lg: "71%" },
        maxWidth: { lg: "876px" },
        backgroundColor: "white",
        paddingTop: { xs: "24px", sm: "none" },
        borderRadius: { xs: "8px", sm: "none" },
        marginBottom: { xs: "24px", sm: "none" },
        boxShadow: {
          xs: "0px 1px 1px rgba(0, 0, 0, 0.14), 0px 2px 1px rgba(0, 0, 0, 0.12), 0px 1px 3px rgba(0, 0, 0, 0.2)",
          sm: "none",
        },
      }}
    >
      {mobMatch ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
            alignItems: "center",
            paddingX: "16px",
          }}
        >
          <Box>
            <Typography
              variant="subtitle1"
              fontSize="16px"
              lineHeight="24px"
              fontWeight="600"
              color="text.primary"
            >
              Machinery by Equippo
            </Typography>
            <Typography
              variant="body2"
              fontFamily="Inter"
              fontWeight="400"
              fontSize="14px"
              lineHeight="20px"
              color="#616161"
            >
              6 results
            </Typography>{" "}
          </Box>
          <MobButtons
            onClick={toggleDrawerSort(true)}
            text="Sort by"
            icon={
              <img
                src={sort}
                alt="sort"
                style={{ color: "#1F1F1F", marginRight: "4px" }}
              />
            }
          />
        </Box>
      ) : (
        <>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
              marginLeft: { xs: "16px", md: "0" },
            }}
          >
            <Typography
              variant={mobMatch ? "subtitle1" : "h2"}
              fontSize={mobMatch ? "16px" : "32px"}
              lineHeight={mobMatch ? "24px" : "36px"}
              fontWeight={mobMatch ? "600" : "700"}
              color="text.primary"
            >
              Machinery by Equippo
            </Typography>
            {!mobMatch && (
              <Button
                typoVariant="subtitle2"
                variant="outlined"
                bgColor="#FFF"
                txColor="primary.main"
                sx={{ height: "36px", boxShadow: "none" }}
                hoverBg="primary.main"
                hoverTxColor="white"
                startIcon={
                  <IosShareIcon
                    sx={{
                      marginRight: "-5px",
                      height: "15px",
                      width: "15px",
                      marginBottom: "4px",
                    }}
                  />
                }
              >
                Share
              </Button>
            )}
          </Box>
          <Typography
            variant="body2"
            fontFamily="Inter"
            fontWeight="400"
            fontSize="14px"
            lineHeight="20px"
            color="#616161"
            sx={{ marginLeft: { xs: "16px", md: "0" } }}
          >
            6 results
          </Typography>
        </>
      )}
      <Box
        sx={{
          display: "flex",
          marginTop: "16px",
          justifyContent: "space-between",
        }}
      >
        <Box
          sx={{
            display: { xs: "none", md: "flex" },
            alignItems: "center",
            columnGap: "8px",
          }}
        >
          <Typography
            variant="body1"
            fontWeight="400"
            fontSize="16px"
            lineHeight="24px"
            color="text.primary"
          >
            Show only
          </Typography>
          <Button
            variant="outlined"
            bgColor={tab == 0 ? "#255CCE1A" : "#F5F5F5"}
            outColor={tab == 0 ? "#255CCE" : ""}
            onClick={() => setTab(0)}
            sx={{
              maxWidth: "146px",
              minWidth: "146px",
              height: "36px",
              padding: "6px 8px",
              border: tab == 1 && "none",
              "&:hover": {
                border: tab == 1 && "none",
              },
            }}
            size="lg"
            txColor="text.primary"
            typoVariant="body1"
            fontWeight="400"
            startIcon={<img src={pro_black} />}
          >
            Pro Machinery
          </Button>
          <Button
            variant="outlined"
            bgColor={tab == 1 ? "#255CCE1A" : "#F5F5F5"}
            outColor={tab == 1 ? "#255CCE" : ""}
            onClick={() => setTab(1)}
            sx={{
              minWidth: "97px",
              height: "36px",
              padding: "6px 8px",
              border: tab == 0 && "none",
              "&:hover": {
                border: tab == 0 && "none",
              },
            }}
            size="lg"
            txColor="text.primary"
            typoVariant="body1"
            fontWeight="400"
          >
            with Video
          </Button>
        </Box>
        {!mobMatch && (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              columnGap: "8px",
            }}
          >
            <Typography
              variant="body1"
              fontWeight="400"
              fontSize="16px"
              lineHeight="24px"
              color="text.primary"
            >
              Sort by
            </Typography>
            <Field
              value={sortVal}
              handleChange={handleSortVal}
              label=""
              height="36px"
              star={false}
              endIcon={<KeyboardArrowDownIcon sx={{ color: "#808080" }} />}
              sx={{ width: "150px" }}
              select={true}
              filled={false}
            >
              {filters.map((f) => (
                <MenuItem key={f.val} value={f.val}>
                  {f.label}
                </MenuItem>
              ))}
            </Field>
          </Box>
        )}
      </Box>
      <Box
        sx={{
          display: { xs: "flex", md: "block" },
          justifyContent: { xs: "center" },
          flexWrap: "wrap",
          width: { xs: "100vw", md: "auto" },
          marginX: { xs: "auto", md: "auto" },
          columnGap: { xs: "32px", md: "0px" },
          marginTop: { xs: "10px", md: "54px" },
        }}
      >
        {list.map((li, i) => (
          <>
            <ListingCard
              key={li}
              handleSnackbarOpen={handleSnackbarOpen}
              setShowShareModal={setShowShareModal}
              showCompare={showCompare}
              comparing={comparing}
              setShowCompare={setShowCompare}
              count={count}
              sx={{
                marginBottom: "24px",
                flex: { xs: "100%", sm: "50%", md: "0 1 auto" },
              }}
            />
            {!mobMatch && i != list.length - 1 && (
              <Box
                sx={{
                  height: "1px",
                  width: tabMatch ? "93.8%" : "100%",
                  backgroundColor: "#D6D6D6",
                  marginBottom: "24px",
                }}
              ></Box>
            )}
          </>
        ))}
      </Box>
      <Snackbar
        open={showSnackbar}
        handleClose={handleSnackbarClose}
        message={
          count >= 2
            ? `Compare ${count} machinery`
            : "Select 1 more machinery to compare."
        }
        button={count >= 2 ? 1 : 0}
        btn1Label="Compare now"
        btn1OnClick={handleCompare}
      />
    </Box>
  );

  return mobMatch ? (
    <Box sx={{ backgroundColor: "transparent", position: "relative" }}>
      <img
        src={seller_mob}
        width="100%"
        height="200px"
        style={{ objectFit: "cover" }}
      />
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          position: "absolute",
          top: "20px",
          width: "100%",
          paddingX: "16px",
        }}
      >
        <Btn
          variant="contained"
          sx={{
            maxWidth: 32,
            maxHeight: 32,
            minWidth: 32,
            minHeight: 32,
            borderRadius: "50%",
            backgroundColor: "#FFF",
            color: "text.primary",
            boxShadow:
              "0px 1px 1px rgba(0, 0, 0, 0.14), 0px 2px 1px rgba(0, 0, 0, 0.12), 0px 1px 3px rgba(0, 0, 0, 0.2)",
            "&:hover": {
              backgroundColor: "#FFF",
              color: "text.primary",
            },
          }}
        >
          <ArrowBackIcon
            sx={{
              color: "primary.main",
              width: "20px",
            }}
          />
        </Btn>
        <Btn
          variant="contained"
          sx={{
            maxWidth: 32,
            maxHeight: 32,
            minWidth: 32,
            minHeight: 32,
            borderRadius: "50%",
            backgroundColor: "#FFF",
            color: "text.primary",
            boxShadow:
              "0px 1px 1px rgba(0, 0, 0, 0.14), 0px 2px 1px rgba(0, 0, 0, 0.12), 0px 1px 3px rgba(0, 0, 0, 0.2)",
            "&:hover": {
              backgroundColor: "#FFF",
              color: "text.primary",
            },
          }}
        >
          <IosShareIcon
            sx={{
              color: "primary.main",
              width: "20px",
            }}
          />
        </Btn>
      </Box>
      <Box
        sx={{
          width: "96px",
          height: "96px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          boxShadow:
            "0px 1px 1px rgba(0, 0, 0, 0.14), 0px 2px 1px rgba(0, 0, 0, 0.12), 0px 1px 3px rgba(0, 0, 0, 0.2)",
          borderRadius: "8px",
          position: "absolute",
          left: "50%",
          top: "180px",
          backgroundColor: "white",
          transform: "translate(-50%, 0)",
        }}
      >
        <img src={eq} width="70px" height="74px" />
      </Box>
      <Box sx={{ marginTop: "100px", marginBottom: "24px" }}>{Equipo()}</Box>
      {listingComponent}
      <BottomSortModal open={showSortBy} toggleDrawer={toggleDrawerSort} />
    </Box>
  ) : (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <Box
        sx={{
          display: { xs: "none", sm: "block" },
          height: "1px",
          width: "100%",
          backgroundColor: "#D6D6D6",
        }}
      ></Box>
      <Box
        sx={{
          marginY: "32px",
        }}
      >
        <Box
          sx={{
            marginLeft: "24px",
            marginBottom: "32px",
          }}
        >
          <BreadCrumbs breadCrumbList={["Seller Profiles", "Equippo"]} />
        </Box>
        <img
          src={seller_bg}
          height="300px"
          width="100%"
          style={{ backgroundSize: "cover", maxWidth: "1280px" }}
        />
        <Box
          sx={{
            marginTop: "48px",
            marginLeft: "24px",
            marginBottom: "4px",
            display: "flex",
            position: "relative",
          }}
        >
          {listingComponent}
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              width: "24%",
              maxWidth: "300px",
              minHeight: "1108px",
              backgroundColor: "white",
              borderRadius: "8px",
              border: "1px solid #D6D6D6",
              position: "absolute",
              left: "900px",
              top: "-200px",
              padding: "24px",
            }}
          >
            <img src={eq} width="90px" height="96px" />
            <Box
              sx={{
                backgroundColor: "#D6D6D6",
                width: "100%",
                height: "1px",
                marginY: "24px",
              }}
            ></Box>
            {Equipo()}
          </Box>
        </Box>
      </Box>
      <SellerShareModal
        open={showShareModal}
        setOpen={setShowShareModal}
        setEmbedOpen={setShowEmbedModal}
      />
      <EmbedModal open={showEmbedModal} setOpen={setShowEmbedModal} />
    </Box>
  );
};

function Equipo() {
  return (
    <>
      <Box
        sx={{
          backgroundColor: "white",
          padding: { xs: "24px 16px", sm: "0" },
          marginBottom: "24px",
          borderRadius: "8px",
          boxShadow: {
            xs: "0px 1px 1px rgba(0, 0, 0, 0.14), 0px 2px 1px rgba(0, 0, 0, 0.12), 0px 1px 3px rgba(0, 0, 0, 0.2)",
            sm: "none",
          },
        }}
      >
        <Typography
          variant="subtitle1"
          fontFamily="Inter"
          fontSize="16px"
          lineHeight="24px"
          fontWeight="600"
          color="text.primary"
        >
          About Equippo
        </Typography>
        <Typography
          variant="body2"
          fontFamily="Inter"
          fontSize="14px"
          lineHeight="20px"
          fontWeight="400"
          color="#616161"
          sx={{ marginTop: "8px", marginBottom: "24px" }}
        >
          We are a sales team with extensive experience from various fields in
          the sale of construction and in a 118 characters.
        </Typography>
        <Button
          variant="contained"
          bgColor="#F9D548"
          txColor="text.primary"
          size="lg"
          sx={{
            height: "48px",
            width: "100%",
            boxShadow: "none",
          }}
          hoverBg="#F3C04F"
        >
          Contact Seller
        </Button>
      </Box>
      <Box
        sx={{
          backgroundColor: "white",
          padding: { xs: "24px 16px", sm: "0" },
          marginBottom: "24px",
          borderRadius: "8px",
          boxShadow: {
            xs: "0px 1px 1px rgba(0, 0, 0, 0.14), 0px 2px 1px rgba(0, 0, 0, 0.12), 0px 1px 3px rgba(0, 0, 0, 0.2)",
            sm: "none",
          },
        }}
      >
        <Typography
          variant="subtitle1"
          fontFamily="Inter"
          fontSize="16px"
          lineHeight="24px"
          fontWeight="600"
          color="text.primary"
          sx={{ marginBottom: "8px" }}
        >
          Equipments we have
        </Typography>
        {equipments.map((eq) => (
          <Typography
            variant="body2"
            fontFamily="Inter"
            fontSize="14px"
            lineHeight="20px"
            fontWeight="400"
            color="#616161"
          >
            {eq}
          </Typography>
        ))}
      </Box>{" "}
      <Box
        sx={{
          backgroundColor: "white",
          padding: { xs: "24px 16px", sm: "0" },
          marginBottom: "24px",
          borderRadius: "8px",
          boxShadow: {
            xs: "0px 1px 1px rgba(0, 0, 0, 0.14), 0px 2px 1px rgba(0, 0, 0, 0.12), 0px 1px 3px rgba(0, 0, 0, 0.2)",
            sm: "none",
          },
        }}
      >
        <Typography
          variant="subtitle1"
          fontFamily="Inter"
          fontSize="16px"
          lineHeight="24px"
          fontWeight="600"
          color="text.primary"
          sx={{ marginBottom: "8px" }}
        >
          Location
        </Typography>
        <Typography
          variant="body2"
          fontFamily="Inter"
          fontSize="14px"
          lineHeight="20px"
          fontWeight="400"
          color="#616161"
          sx={{ marginBottom: "24px" }}
        >
          Equippo AG , Germany
        </Typography>
        <Box sx={{ position: "relative" }}>
          <img
            src={Map}
            height="155px"
            width="100%"
            style={{ borderRadius: "8px" }}
          />
          <Button
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              width: "130px",
              height: "36px",
              borderRadius: "4px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              paddingX: "auto",
              transform: "translate(-50%, -50%)",
            }}
            bgColor="#fff"
            typoVariant="subtitle"
            fontWeight="600"
            txColor="#255CCE"
            outColor="#255CCE"
            typoSize="14px"
            hoverBg="primary.main"
            hoverTxColor="white"
            variant="outlined"
          >
            View on Map
          </Button>
        </Box>
      </Box>
    </>
  );
}

function MobButtons({ text, icon, onClick }) {
  return (
    <Box
      onClick={onClick}
      sx={{
        width: "83px",
        height: "36px",
        border: "1px solid #BFBFBF",
        borderRadius: "4px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "white",
        padding: "8px auto",
      }}
    >
      {icon}
      <Typography
        variant="body2"
        fontWeight="400"
        fontSize="14px"
        lineHeight="20px"
        color="text.primary"
      >
        {text}
      </Typography>
    </Box>
  );
}

export default Seller;
